<template>
  <div class="flex flex-col">
    <label
      class="mb-1"
      :for="labelPlaceholder"
      v-if="labelPlaceholder && !readonly"
    >{{ labelPlaceholder }}</label>
    <div class="flex items-center">
      <button type="button" :class="buttonClasses" @click="setNumericValue(-1)">
        -
      </button>
      <input
        ref="input"
        class="flex-1 w-20 h-5 mx-1 text-white bg-transparent border-2 border-orange-500 border-solid rounded"
        :min="minValue"
        :maxlength="maxlength"
        :id="elementId"
        :placeholder="placeholder"
        :type="type"
        :value="value"
        :class="{
          focus: focused,
          readonly: readonly,
          disabled: disabled,
          editable: editable
        }"
        :disabled="disabled"
        :readonly="readonly"
        :name="name"
        v-on:change="inputChanged"
        @keypress="allowOnlyNumbers"
      />
      <button type="button" :class="buttonClasses" @click="setNumericValue(1)">
        +
      </button>
    </div>
    <span
      v-if="this.error && this.error !== ''"
      class="py-1 text-xs text-red-600"
      >{{ showError }}</span
    >
  </div>
</template>
<script>
import { allowOnlyNumbers } from "../../utils/inputHelpers";
export default {
  name: "grafokett-number-input",
  components: {},
  data() {
    return {
      isFocused: false,
      dataChanged: false,
      internalError: "",
      buttonClasses:
        "flex items-center justify-center flex-none w-6 text-lg font-bold bg-orange-500 border border-orange-500 text-primary rounded"
    };
  },
  beforeMount() {
    this.internalVal = this.value || 0;
  },
  watch: {
    value(val) {
      if (!this.validateLength) {
        this.dataChanged = true;
      } else {
        if (val.length !== this.validateLength) {
          this.internalError = `Invalid length, a length of ${
            this.validateLength
          } is required`;
        } else {
          this.internalError = "";
          this.dataChanged = true;
        }
      }
    }
  },
  computed: {
    showError() {
      if (this.error) {
        return this.error;
      } else if (this.internalError !== "") {
        return this.internalError;
      }
      return "";
    },
    elementId() {
      return this.id ? this.id : this.labelPlaceholder;
    },
    focused() {
      if (
        this.value &&
        this.value !== "" &&
        !this.disabled &&
        this.labelPlaceholder &&
        this.labelPlaceholder !== ""
      ) {
        if (this.type === "number" && isNaN(this.value)) {
          return false;
        }
        return true;
      }

      if (this.value && this.value !== "" && this.editable) {
        if (this.type === "number" && isNaN(this.value)) {
          return false;
        }
        return true;
      }
      return this.isFocused;
    }
  },
  props: {
    id: {
      type: String,
      required: false
    },
    value: {
      default: ""
    },
    readonly: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    isInput: {
      type: Boolean,
      default: true
    },
    labelPlaceholder: {
      type: String
    },
    validateLength: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 50
    },
    name: {
      type: String
    },
    error: {
      type: String
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    inlineSave: {
      type: Boolean,
      default: false
    },
    minValue: {
      type: Number,
      default: 0
    }
  },

  methods: {
    setNumericValue(modifier) {
      const value = Math.max(parseInt(this.value || 0) + modifier, 0);
      this.$emit("input", value);
    },
    inputChanged($event) {
      const value = parseInt($event.target.value || 0);
      this.$emit("input", value);
    },
    allowOnlyNumbers
  }
};
</script>

<style lang="postcss"></style>
